<style lang="scss">
@import '../css/sub.scss';
</style>
<template>
  <div class="donga-audit">
    <audit-header></audit-header>
    <div class="audit-template sub-template">
      <div role="sub" class="audit-sub">
        <div id="sub-sections">
          <div class="visual-top report">
            <h2 class="page-tit">제보안내</h2>
            <p class="page-sub-tit pc-show">사이버 감사실과 제보자간의 쌍방향 소통방식으로 운영되며 동아쏘시오 그룹사 임직원 뿐만 아니라<br>고객, 협력회사 등 모든 이해관계자 여러분의 소중한 의견을 자유롭게 제안할 수 있는 곳으로 그룹사와 이해관계자<br>모두의 발전에 도움이 되도록 적극적인 참여 바랍니다.</p>
          </div>
          <div class="col-container pc-container">
            <div class="sub-contents">
              <div class="default-tab report-tab">
                <div class="tabs">
                  <button type="button" class="tab" data-id="reporting" @click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">제보자 보호</button>
                  <button type="button" class="tab" data-id="reporting-target" @click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">제보 대상</button>
                  <button type="button" class="tab" data-id="reporting-tipping" @click="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]">제보방법 및 처리절차</button>
                  <button type="button" class="tab" data-id="reporting-etc" @click="activetab=4" v-bind:class="[ activetab === 4 ? 'active' : '' ]">기타 제보방법</button>
                </div>
              </div>
                <section class="sub-section" id="reporting" v-if="activetab === 1">
                  <div class="sub-column">
                    <h3 class="section-tit title">제보자 보호 대상 및 의무</h3>
                    <ul class="default-list reporting-list">
                      <li class="list-item">
                        <i class="item-icon first"></i>
                        <p class="item-txt">모든 임직원은 직무상 또는 우연히 제보자의 신분을 인지하였더라도 제보자의 신분을 누설하여서는 안됨</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon second"></i>
                        <p class="item-txt">제보자의 신분에 대한 문의, 제보자를 알아내기 위한 탐문활동 등 신분노출이 가능한 모든 행위 금지</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon third"></i>
                        <p class="item-txt">본인의 동의 없이 제보자 및 조사 협조자의 신분공개 또는 암시 금지</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon fourth"></i>
                        <p class="item-txt">제보자가 제시한 증거 또는 제보 관련 수집정보, 제보 이후 결과에 대한 사후조치에 대한 정보 유출금지</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon fifth"></i>
                        <p class="item-txt">신분보호의무 위반 시 관련자를 처벌할 수 있음</p>
                      </li>
                    </ul>
                  </div>
                  <div class="sub-column second">
                    <h3 class="section-tit title">제보자 보호 정책</h3>
                    <ol class="default-ordered-list">
                      <li>1. 제보자 및 제보내용은 감사실 내에서도 대외비로 엄격히 처리되고 있습니다.</li>
                      <li>2. CLEAN :D의 제보시스템은 안전한 보안체계로 보호되고 있습니다.</li>
                      <li>3. 제보 처리는 제보 내용에 대한 엄격한 비밀준수를 서약한 제한된 인원에 의해 수행되고 있습니다.</li>
                      <li>4. 제보자에 대한 불이익 금지 및 위반 시 관련자를 처벌할 수 있습니다.</li>
                      <li>5. 본인이 관련된 부정, 비리의 경우, 충분한 정상참작을 통한 처리가 이루어질 것입니다.</li>
                    </ol>
                  </div>
                </section>
                <section class="sub-section" id="reporting-target" v-else-if="activetab === 2">
                  <div class="sub-column">
                    <h3 class="section-tit title">대상 회사</h3>
                    <p class="section-sub-tit m-show">동아쏘시오그룹 전체 그룹사</p>
                    <div class="pc-show compyny-logos">
                      <img src="../img/target-company.png" alt="동아쏘시오 홀딩스, 동아제약, 동아ST, 에스티젠바이오, 에스티팜, 동아오츠카, 동아참메드, 동천수, 용마로지스, 수석, DA인포메이션, 철근종합건설, sinto 한국신동공업(주), AbTis">
                    </div>
                  </div>
                  <div class="sub-column second target-action">
                    <h3 class="section-tit title">대상 행위</h3>
                    <ul class="default-list target-list">
                      <li class="list-item">
                        <i class="item-icon first"></i>
                        <p class="item-txt">직무와 관련하여 이해관계자로부터 금품 또는 향응을 수수하는 행위 </p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon second"></i>
                        <p class="item-txt">임직원의 불공정한 거래회사 선정</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon third"></i>
                        <p class="item-txt">우월적 지휘 남용을 이용한 관계의 불합리성</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon fourth"></i>
                        <p class="item-txt">임직원의 회사비용 횡령 및 회사자산의 불법/부당 사용</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon fifth"></i>
                        <p class="item-txt">폭행, 괴롭힘, 성희롱 등 근무기강 해이 관련 사항</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon sixth"></i>
                        <p class="item-txt">채용, 인력유출 등의 인사 관련 불만</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon seventh"></i>
                        <p class="item-txt">기술자료, 영업기밀, 개인정보 등 회사와 관련한 각종 정보 유출</p>
                      </li>
                      <li class="list-item">
                        <i class="item-icon eighth"></i>
                        <p class="item-txt">기타 직무와 관련된 비윤리적 행위 및 각종 제안/제보</p>
                      </li>
                    </ul>
                    <p class="target-notice">(※제보 내용이 사업의 투명성 제고 및 윤리적인 기업문화 정착에 구체적 기여를 한 경우, 당사 자체의 심의를 거쳐 소정의 사례를 할 수 있습니다.)</p>
                    <p class="target-notice-bold">무고, 근거 없는 비방 등은 제보의 대상이 아닙니다.</p>
                  </div>
                </section>
                <section class="sub-section" id="reporting-tipping" v-else-if="activetab === 3">
                  <div class="sub-column">
                    <h3 class="section-tit title">제보방법</h3>
                    <ul class="default-list tipping-list">
                      <li class="list-item">
                        <span class="item-tit">CLEAN :D 제보</span>
                        <i class="item-icon first"></i>
                        <router-link to="/reporting" class="item-link">제보 바로가기 &#62;</router-link>
                      </li>
                      <li class="list-item">
                        <span class="item-tit">전화제보</span>
                        <i class="item-icon second"></i>
                        <p class="item-txt">02-920-8015</p>
                      </li>
                      <li class="list-item">
                        <span class="item-tit">팩스(FAX)</span>
                        <i class="item-icon third"></i>
                        <p class="item-txt">02-920-2325</p>
                      </li>
                      <li class="list-item">
                        <span class="item-tit">서신 또는 직접방문</span>
                        <i class="item-icon fourth"></i>
                        <p class="item-txt">서울 동대문구 천호대로 64<br>동아쏘시오홀딩스 윤리경영실</p>
                      </li>
                    </ul>
                  </div>
                  <div class="sub-column second processing-procedure">
                    <h3 class="section-tit title">처리절차</h3>
                    <div class="default-img m-show">
                      <img src="../img/tipping-img.png" alt="제보접수 -> 내용확인(등록) -> 조사개시 -> 조사완료 -> 종결 -> 처리결과 확인">
                    </div>
                    <div class="default-img pc-show">
                      <img src="../img/pc-tipping-img.png" alt="제보접수 -> 내용확인(등록) -> 조사개시 -> 조사완료 -> 종결 -> 처리결과 확인">
                    </div>
                  </div>
                </section>
                <section class="sub-section" id="reporting-etc" v-else>
                  <div class="sub-column etc-column">
                    <h3 class="title blind">고객지원센터</h3>
                    <a href="https://www.donga.co.kr/customer/inquiry?lang=ko" class="etc-link default-link" target="_blank">사이버 고객지원센터 바로가기 &#62;</a>
                    <p class="etc-txt">제품불만 및 고객상담은 각 회사별 고객지원부서(회사홈페이지 참고) 또는 당사 홈페이지 사이버 고객지원센터를 이용하시기 바랍니다.</p>
                  </div>
                  <div class="sub-column second">
                    <h3 class="title section-tit">그룹사 감사실 연락처</h3>
                    <p class="section-sub-tit">그룹사의 감사부서에 직접 의견전달 및 제보를 원하시는 분은 아래의 연락처로 연락주시기 바랍니다.</p>
                    <ul class="company-list">
                      <li class="list-item">
                        <h4 class="item-tit">동아쏘시오홀딩스</h4>
                        <div class="item-box">
                          <div class="column-area first">
                            <div class="column">
                              <span class="tit">주소</span>
                              <span class="desc">서울특별시 동대문구 천호대로 64. 동아쏘시오홀딩스 윤리경영실</span>
                            </div>
                            <div class="column">
                              <span class="tit">E-mail</span>
                              <span class="desc">audit@donga.co.kr</span>
                            </div>
                          </div>
                          <div class="column-area">
                            <div class="column">
                              <span class="tit tel">TEL</span>
                              <span class="desc tel">02-920-8015</span>
                            </div>
                            <div class="column">
                              <span class="tit fax">FAX</span>
                              <span class="desc fax">02-924-2325</span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-item">
                        <h4 class="item-tit">동아에스티, 참메드</h4>
                        <div class="item-box">
                          <div class="column-area first">
                            <div class="column">
                              <span class="tit">주소</span>
                              <span class="desc">서울특별시 동대문구 천호대로 64. 동아에스티 지속가능경영실</span>
                            </div>
                            <div class="column">
                              <span class="tit">E-mail</span>
                              <span class="desc">st-audit@donga.co.kr</span>
                            </div>
                          </div>
                          <div class="column-area">
                            <div class="column">
                              <span class="tit tel">TEL</span>
                              <span class="desc tel">02-920-8953</span>
                            </div>
                            <div class="column">
                              <span class="tit fax">FAX</span>
                              <span class="desc fax">02-920-8023</span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-item">
                        <h4 class="item-tit">동아제약</h4>
                        <div class="item-box">
                          <div class="column-area first">
                            <div class="column">
                              <span class="tit">주소</span>
                              <span class="desc">서울특별시 동대문구 천호대로 64. 동아제약 감사실</span>
                            </div>
                            <div class="column">
                              <span class="tit">E-mail</span>
                              <span class="desc">pharm-audit@donga.co.kr</span>
                            </div>
                          </div>
                          <div class="column-area">
                            <div class="column">
                              <span class="tit tel">TEL</span>
                              <span class="desc tel">02-920-8291</span>
                            </div>
                            <div class="column">
                              <span class="tit fax">FAX</span>
                              <span class="desc fax">02-920-8039</span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-item">
                        <h4 class="item-tit">동아오츠카</h4>
                        <div class="item-box">
                          <div class="column-area first">
                            <div class="column">
                              <span class="tit">주소</span>
                              <span class="desc">서울특별시 동대문구 용신동 249-1 동아오츠카 감사실</span>
                            </div>
                            <div class="column">
                              <span class="tit">E-mail</span>
                              <span class="desc">otsuka-audit@donga.co.kr</span>
                            </div>
                          </div>
                          <div class="column-area">
                            <div class="column">
                              <span class="tit tel">TEL</span>
                              <span class="desc tel">02-2170-7708</span>
                            </div>
                            <div class="column">
                              <span class="tit fax">FAX</span>
                              <span class="desc fax">02-2170-7793</span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-item">
                        <h4 class="item-tit">에스티팜</h4>
                        <div class="item-box">
                          <div class="column-area first">
                            <div class="column">
                              <span class="tit">주소</span>
                              <span class="desc">서울특별시 강남구 영동대로 520 (삼성동, 아이파크타워) 지속가능경영실</span>
                            </div>
                            <div class="column">
                              <span class="tit">E-mail</span>
                              <span class="desc">stp-audit@donga.co.kr</span>
                            </div>
                          </div>
                          <div class="column-area">
                            <div class="column">
                              <span class="tit tel">TEL</span>
                              <span class="desc tel">02-527-6368</span>
                            </div>
                            <div class="column">
                              <span class="tit fax">FAX</span>
                              <span class="desc fax">02-2038-8605</span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-item">
                        <h4 class="item-tit">이외 그룹사 (대상회사: 에스티젠바이오, 용마로지스, 수석, 한국신동, 동천수, DA Information, 아벤종합건설, 앱티스)</h4>
                        <div class="item-box">
                          <div class="column-area first">
                            <div class="column">
                              <span class="tit">주소</span>
                              <span class="desc">서울특별시 동대문구 천호대로 64. 동아쏘시오홀딩스 윤리경영실</span>
                            </div>
                            <div class="column">
                              <span class="tit">E-mail</span>
                              <span class="desc">audit@donga.co.kr</span>
                            </div>
                          </div>
                          <div class="column-area">
                            <div class="column">
                              <span class="tit tel">TEL</span>
                              <span class="desc tel">02-920-8015</span>
                            </div>
                            <div class="column">
                              <span class="tit fax">FAX</span>
                              <span class="desc fax">02-924-2325</span>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>
<script>
import AuditHeader from '@/components/AuditHeader'
import AuditFooter from '@/components/AuditFooter'
export default {
  name: 'ReportGuide',
  components: {
    'audit-header': AuditHeader,
    'audit-footer': AuditFooter
  },
  data () {
    return {
      activetab: 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ReportGuide.vue